import React, { Component } from 'react';

import Button from 'components/Button';
import Header from 'components/Header';

import './styles.css';

class NotFound extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="not-found">
        <Header light />

        <div className="info">
          <h1 className="info__title">Page not found</h1>
          <p className="info__paragraph">We couldn’t find the page you requested. Please double check your spelling, try again later or click on the button below.</p>
          <div className="info__button">
            <Button
              color="blue"
              size="medium"
              text="Go back"
              href="/"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/scenes/NotFound/index.jsx